import React from "react";

import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row, FormText
} from "reactstrap";

import SelectListComponent from "../utils/selectList";
import DateSelector from "../utils/dateSelector";

const AuditPanel = ({
  actions,
  handleSelectChange,
  handleUserChange,
  selectedAction,
  handleDateChange,
  componentErrorMessages,
  onSearch,
  selectedName,
  users,
  startDateChange,
  endDateChange
}) => {
  return (
    <Form onSubmit={e => e.preventDefault()}>
      <Container>
        <Row>
          <Col xs="6" sm="2">
            <FormGroup className="mb-4">
              <Label>Start Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="startDate"
                onValueChange={(date) => handleDateChange(date, 'startDate')}

              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="2">
            <FormGroup className="mb-4">
              <Label>End Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="endDate"
                onValueChange={(date) => handleDateChange(date, 'endDate')}

              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="3">
            <FormGroup className={"mb-0 " + (componentErrorMessages.auditAction ? 'has-danger' : '')}>
              <Label>Action</Label>
              <SelectListComponent 
              placeholder={'Select action...'} 
              data={actions} 
              valueKey='value' 
              textField='label' 
              selectValue={selectedAction} 
              onValueChange={(event) => { handleSelectChange(event, 'auditAction') }} />
              {componentErrorMessages.auditAction && <FormText color="danger"> {componentErrorMessages.auditAction}</FormText>}
            </FormGroup>
          </Col>
          <Col xs="6" sm="3">
            <FormGroup className={"mb-0 " + (componentErrorMessages.userName ? 'has-danger' : '')}>
              <Label>User Name</Label>
              <SelectListComponent 
              placeholder={'Select User...'} 
              data={users} 
              valueKey='value'
               textField='label' 
              selectValue={selectedName} 
              onValueChange={(event) => { handleUserChange(event, 'userName') }} />
              {componentErrorMessages.userName && <FormText color="danger"> {componentErrorMessages.userName}</FormText>}
            </FormGroup>
          </Col>
          <Col xs="6" sm="1">
            <label>&nbsp;</label>
            <Button className="btn-avi-primary" onClick={() => onSearch()}>
              Search
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

export default AuditPanel;



// WEBPACK FOOTER //
// ./src/views/audit-trail/audit-panel.js